import CardNameEdit from './CardNameEdit';

export default CardNameEdit;
